module.exports = __webpack_public_path__ + "static/media/ic_date_payment.507f5c8a.svg";